export interface Notification {
  id: string;
  notificationId: string;
  title: string;
  content: string;
  type: NotificationType;
  isRead: boolean;
  targetType: string;
  targetId: string;
  link: string;
  createdAt: string;
}
export enum NotificationType {
  MEETING_INVITE = "meeting_invite",
  MEETING_REMINDER = "meeting_reminder",
  MEETING_STARTED = "meeting_started",
  MEETING_ENDED = "meeting_ended",
  MEETING_CANCELLED = "meeting_cancelled",
  SYSTEM = "system",
  NORMAL = "normal",
}

export interface NotificationListParams {
  type?: NotificationType;
  isRead?: boolean;
  page?: number;
  pageSize?: number;
  sortBy?: "createdAt" | "updatedAt";
  sortOrder?: "asc" | "desc";
}

export interface NotificationStatistics {
  total: number;
  unread: number;
  read: number;
  byType: Record<string, number>;
  recent: number;
}

export interface NotificationUnreadCount {
  unreadCount: number;
}
